export default function (name, opts) {
  const widgetName = name;
  const widgetOpts = opts;
  const clientPath = SITEBASEURL;

  let swiperInstance = null;
  let swiperContentInstance = null;

  function getSwiperContainers() {
    const isMobile = window.matchMedia('(max-width: 1200px)').matches;

    return `
      <div class="swiper-container swiper-container-images">
        <div class="swiper-wrapper">
          ${isMobile ? '' : '<div class="swiper-pagination"></div>'}
        </div>
      </div>
      
      <div class="content-wraper">
            ${
              isMobile
                ? `
        <div class="pagination-with-arrows">
          <div class="swiper-button-prev"></div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-next"></div>
        </div>
      `
                : ''
            }
        ${isMobile ? '' : '<div class="swiper-button-prev"></div>'}
          <div class="swiper-container swiper-container-content">
            <div class="swiper-wrapper"></div>
          </div>  
        ${isMobile ? '' : '<div class="swiper-button-next"></div>'}
      </div>`;
  }

  // Slide Template - Images
  function buildSlideTemplateImages(slide) {
    const template = `
      <div class="swiper-slide">
        <div class="swiper-image-container swiper-lazy" data-background="${slide.ImageWithPath}" aria-label="${slide.ImageAlternateText}">
          <div class="swiper-lazy-preloader"></div>
        </div>
      </div>`;

    return template;
  }

  // Slide Template - Content
  function buildSlideTemplateContent(slide) {
    const title = `<h2 class="slide-title">${slide.Title}</h2>`;

    const buttons = function (btn1, btn1Text, btn2, btn2Text) {
      if (btn1 || btn2) {
        let btnContainer = $('<div class="button-container"></div>');
        if (btn1) {
          const target = btn1.startsWith(clientPath) ? '' : ' target="_blank"';
          btnContainer.append(`<a href="${btn1}" class="button"${target}>${btn1Text}</a>`);
        }
        if (btn2) {
          const target = btn2.startsWith(clientPath) ? '' : ' target="_blank"';
          btnContainer.append(`<a href="${btn2}" class="button"${target}>${btn2Text}</a>`);
        }
        return btnContainer.prop('outerHTML');
      } else {
        return '';
      }
    };

    const template = `
      <div class="swiper-slide">
        <div class="swiper-content-container">
          <div class='content-wrap ${!slide.URL && !slide.PurchaseURL ? 'no-btns' : ''}'>
          ${title}
          ${buttons(slide.URL, slide.DetailLinkText, slide.PurchaseURL, slide.PurchaseLinkText)}
          </div>
        </div>
      </div>
    `;
    return template;
  }

  // Swiper Initialization
  function initSwiper(widgetData) {
    // Destroy previous instances if they exist
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
    }
    if (swiperContentInstance) {
      swiperContentInstance.destroy(true, true);
    }

    // Rebuild HTML structure based on current screen size
    $(`#${widgetName}`).html(getSwiperContainers());

    const swiperWidgetImagesWrapper = $(`#${widgetName} .swiper-container-images .swiper-wrapper`);
    const swiperWidgetContentWrapper = $(
      `#${widgetName} .swiper-container-content .swiper-wrapper`,
    );

    widgetData.forEach(function (slide) {
      swiperWidgetImagesWrapper.append(buildSlideTemplateImages(slide));
      swiperWidgetContentWrapper.append(buildSlideTemplateContent(slide));
    });

    swiperInstance = new Swiper(`#${widgetName} .swiper-container-images`, {
      speed: 600,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      loop: widgetData.length > 1,
      watchOverflow: true,
      spaceBetween: 0,
      centeredSlides: false,
      preloadImages: true,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: `#${widgetName} .swiper-button-next`,
        prevEl: `#${widgetName} .swiper-button-prev`,
      },
      pagination: {
        el: `#${widgetName} .swiper-pagination`,
        clickable: true,
      },
    });

    swiperContentInstance = new Swiper(`#${widgetName} .swiper-container-content`, {
      speed: 600,
      spaceBetween: 0,
      centeredSlides: false,
      loop: widgetData.length > 1,
      a11y: true,
      autoHeight: true,
      effect: 'fade',
      watchOverflow: true,
      fadeEffect: {
        crossFade: true,
      },
    });

    swiperInstance.controller.control = swiperContentInstance;
    swiperContentInstance.controller.control = swiperInstance;

    if (widgetData.length === 1) {
      $(`#${widgetName}`).addClass('single-slide');
      $(`#${widgetName} .swiper-pagination`).remove();
    } else {
      $(`#${widgetName}`).addClass('multiple-slides');
    }
  }

  function handleResize(widgetData) {
    const currentIsMobile = window.matchMedia('(max-width: 1200px)').matches;

    if (
      typeof handleResize.prevIsMobile === 'undefined' ||
      handleResize.prevIsMobile !== currentIsMobile
    ) {
      initSwiper(widgetData);
      handleResize.prevIsMobile = currentIsMobile;
    }
  }

  saffire.utils.getWidgetData(widgetOpts).then(function (response) {
    if (response.Slides.length > 0) {
      $(`#${widgetName}`).html(getSwiperContainers());
      initSwiper(response.Slides);

      $(window).on('resize', function () {
        handleResize(response.Slides);
      });
    } else {
      $(`#${widgetName}`).remove();
      console.log(response);
      console.log('Error: No Data for swiperWidget');
    }
  });
}
